// Логото на UnrealSoft (public/logo-ts.png — едноцветен силует) като МАСКА,
// оцветена с --color-logo: така следва цвета на темата, а в „Оранжево“ и
// тъмното оранжево е точно оранжевият на файла. Размерът идва от className,
// както беше на <img>; без ширина пропорцията е тази на файла (681×795), а при
// квадратна кутия силуетът се вписва в средата (като object-contain).
export default function BrandLogo({
  className = "",
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <span
      role="img"
      aria-label="UnrealSoft"
      onClick={onClick}
      className={`inline-block shrink-0 select-none aspect-[681/795] bg-logo [mask-image:url(/logo-ts.png)] [mask-position:center] [mask-repeat:no-repeat] [mask-size:contain] ${className}`}
    />
  );
}
